// src/standalone-wrapper.jsx
// Entry point para el build standalone con Shadow DOM

import React from "react";
import ReactDOM from "react-dom/client";
import Widget from "./widget.jsx";

/**
 * Función para montar el widget standalone usando Shadow DOM
 * Esto aísla completamente los estilos del widget de la página padre
 * 
 * @param {Object} props - Props para pasar al widget (apiKey, etc.)
 * @returns {Object} - Objeto con referencias al shadowRoot, container y root de React
 */
function mountWidget(props = {}) {
    // 1. Crear o encontrar el contenedor en el DOM regular
    let container = document.getElementById("chat-widget-root");

    if (!container) {
        container = document.createElement("div");
        container.id = "chat-widget-root";
        document.body.appendChild(container);
    }

    // 2. Crear Shadow DOM (ya existe? entonces lo reutilizamos)
    let shadowRoot = container.shadowRoot;

    if (!shadowRoot) {
        shadowRoot = container.attachShadow({ mode: "open" });

        // 3. Inyectar estilos CSS en el Shadow DOM
        const styleElement = document.createElement("style");

        // IMPORTANTE: Los estilos se inyectarán aquí en tiempo de build
        // Vite reemplazará este comentario con el CSS real
        styleElement.textContent = `__WIDGET_STYLES__`;

        shadowRoot.appendChild(styleElement);
    }

    // 4. Crear o encontrar el contenedor para React dentro del Shadow DOM
    let reactContainer = shadowRoot.getElementById("widget-react-root");

    if (!reactContainer) {
        reactContainer = document.createElement("div");
        reactContainer.id = "widget-react-root";
        shadowRoot.appendChild(reactContainer);
    }

    // 5. Renderizar React en el Shadow DOM
    const root = ReactDOM.createRoot(reactContainer);
    root.render(<Widget {...props} />);

    console.log("✅ Widget montado en Shadow DOM");

    return {
        shadowRoot,
        reactContainer,
        root,
        unmount: () => {
            root.unmount();
            container.remove();
        }
    };
}

// Crear API global del widget
const ChatWidgetAPI = {
    mount: mountWidget,
    init: mountWidget,  // alias útil
    render: mountWidget // alias amigable
};

// Exponer APIs globales
if (typeof window !== "undefined") {
    window.ChatWidget = ChatWidgetAPI;
}

// Exportar como módulo (no usado en standalone pero recomendado)
export default ChatWidgetAPI;
